import type { FetchRequestArgs } from '../../utils';
import { fetchRequest } from '../../utils';
import { HTTPMethod } from '../httpMethods';

// data: {
//   areaCode,
//   createDepartment,
//   departmentIDs,
//   name,
//   nickname,
//   teamMemberIDs,
//   timezone,
// },
export const createBoard = async <T extends Record<string, unknown>>({
  data,
  headers,
  organizationId,
  domain,
  query,
}: FetchRequestArgs & { organizationId: string }): Promise<
  ReturnType<typeof fetchRequest>
> =>
  fetchRequest<T>({
    data,
    domain,
    endpoint: `/boards/${organizationId}`,
    headers,
    method: HTTPMethod.POST,
    query,
  });
